export const STORAGE_KEY_ACCESS_TOKEN = 'access_token';
export const STORAGE_KEY_ACCESS_TOKEN_EXPIRY_DATE = 'access_token_expiry_date';
export const STORAGE_KEY_CURRENT_USER_PROFILE = 'current_user_profile';
export const STORAGE_KEY_REDIRECT_PATH = 'redirect_path';